module.exports = __webpack_public_path__ + "img/1.2e5d8193.png";